import React from 'react';
import css from '../Login.scss';
import PropTypes from 'prop-types';
import Button from 'Components/Button/Button';
import { FormattedMessage as Translation } from 'react-intl';
import { fileNames } from 'Constants/imageUrls';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { WEBP_TYPE } from 'Constants/images';
import { noop } from 'Helpers/function';

const styles = {
    formText: { marginBottom: '30px' }
};

const NotificationPermission = props => (
    <div className={ css.formContainer }>
        <div className={ css.image }>
            <ImageWrapper
                fileName={ fileNames.NOTIFICATIONS }
                types={ WEBP_TYPE }
            />
        </div>
        <h3 className={ css.formTitle }>
            <Translation id="notificationModalPermissionTitle" />
        </h3>
        <p
            className={ css.formText }
            style={ styles.formText }
        >
            <Translation id="notificationModalPermissionBody" />
        </p>
        <Button
            type="btnMain"
            className={ css.button }
            onClick={ props.onClickGotIt }
        >
            <Translation id="notificationModalPermissionCTA" />
        </Button>
    </div>
);

NotificationPermission.propTypes = {
    onClickGotIt: PropTypes.func
};

NotificationPermission.defaultProps = {
    onClickGotIt: noop
};

export default NotificationPermission;
